import React, { Component, Fragment } from "react";
import { observer, inject } from "mobx-react";
import ModalContainer from "../../modal/ModalContainer";

import { DialogContent,Divider, DialogActions,Typography, Button, Grid, TextField,Switch} from "@material-ui/core";
import moment from "moment";
import SelectField from "../../fields/SelectField";
import Countries from "../../../lookup/Country";

@inject("agentVenueContactStore", "profileStore", "templateStore")
@observer
class AgentVenueContactModal extends Component {
    sigCanvas = {};
    state = {
        isLoading: false,
        venueData: undefined
    }


    componentDidUpdate(prevProps) {
        if (prevProps.open !== this.props.open) {
            var agentVenue = this.props.agentVenue
            if(agentVenue != undefined){
                this.props.templateStore.showLoadingScreen();
                Promise.all([
                    this.props.agentVenueContactStore.getAgentVenueContact(agentVenue.id),
                    this.props.profileStore.getProfileByIdSimple(agentVenue.venueId)
                ]).then((result) => {
                    var venue = result[1]
                    
                    if(!result[0]){
                        this.props.agentVenueContactStore.reset()
                        this.props.agentVenueContactStore.setDefaultValue(venue)
                    }
                    this.setState({
                        venueData: venue
                    })
                    this.props.templateStore.hideLoadingScreen();
                })
    
            }
        }
    }



    onClose = () => {
        this.props.agentVenueContactStore.reset()
        this.props.onClose()
    }

    handleSubmit = () => {
        var agentVenue = this.props.agentVenue
        if(agentVenue != undefined){
            this.props.templateStore.showLoadingScreen();
            this.props.agentVenueContactStore.createOrUpdate(agentVenue.id).then(() => {
                this.props.templateStore.hideLoadingScreen();
                const updatedContactData = {
                    manageContactName: this.props.agentVenueContactStore.manageContactName,
                    manageContactEmail: this.props.agentVenueContactStore.manageContactEmail,
                    manageContactPhone: this.props.agentVenueContactStore.manageContactPhone
                };
                this.props.agentVenueContactStore.reset()
                this.props.templateStore.openSnackbar(`${this.state.venueData.profileName} contact details have been updated`);
                this.setState({
                    venueData: undefined
                })
                if (this.props.onSave) {
                    this.props.onSave(agentVenue.id, updatedContactData);
                }
                this.onClose()
            })
        }
        
    };


    setVenueLegalEntityName = e => this.props.agentVenueContactStore.setVenueLegalEntityName(e.target.value);
    setVenueEmail = e => this.props.agentVenueContactStore.setVenueEmail(e.target.value);
    setVenuePhone = e => this.props.agentVenueContactStore.setVenuePhone(e.target.value);
    setVenueContactName = e => this.props.agentVenueContactStore.setVenueContactName(e.target.value);
    
    setOutgoingInvoiceAddress = e => this.props.agentVenueContactStore.setOutgoingInvoiceAddress(e.target.value);
    handleStreetChangeOutgoing = e => this.props.agentVenueContactStore.setstreetAddress(e.target.value);
    handleCityChangeOutgoing = e => this.props.agentVenueContactStore.setsuburb(e.target.value);
    handlePostalChangeOutgoing = e => this.props.agentVenueContactStore.setPostCode(e.target.value);
    handleStateChangeOutgoing = e => this.props.agentVenueContactStore.setstate(e.target.value);
    handleCountryChangeOutgoing = value => this.props.agentVenueContactStore.setcountry(value);
   
    handleContactPhone = e => this.props.agentVenueContactStore.setContactPhone(e.target.value);
    handleContactName = e => this.props.agentVenueContactStore.setContactName(e.target.value);
    handleManageContactEmail = e => this.props.agentVenueContactStore.setContactEmail(e.target.value);
   
    handleSwitchOn = e => this.props.agentVenueContactStore.setSwitchOn()
    anyError(field) {
        if (!this.props.agentVenueContactStore.errors) return false;
        if (!this.props.agentVenueContactStore.errors[field]) return false;
        return true;
    }
    errorText(field) {
        if (!this.props.agentVenueContactStore.errors) return null;
        if (!this.props.agentVenueContactStore.errors[field]) return null;
        return this.props.agentVenueContactStore.errors[field];
    }

    
    render() {
        const {
            venueLegalEntityName,
            venueEmail,
            streetAddress,
            suburb,
            postCode,
            state,
            country,
            manageContactName,
            manageContactEmail,
            manageContactPhone,
            venuePhone,
            venueContactName,
            switchOn
        } = this.props.agentVenueContactStore;
        const {venueData} = this.state
        const { open, onClose } = this.props;
        let countriesSuggestion = () => {
            return Countries.map(country => {
                return {
                    value: country.code,
                    label: country.name,
                    divider: country.divider
                };
            });
        };
       
        return (
            <ModalContainer open={open} onClose={onClose} onEntered={this.onEntered} title={`${venueData ? venueData.profileName : "Venue"} Contact Information`} coloredDialogTitle={true}>
                <DialogContent>
                    {/* <Grid container spacing={8}>
                        <Grid item xs={12} md={12}>
                            <Grid item xs={12} md={5}>
                                <Switch checked={switchOn} onChange={this.handleSwitchOn} value="hideToolbar" /> Turn on custom contact details
                            </Grid>
                        </Grid>
                    </Grid> */}
                    <Grid container spacing={8} style={{marginTop:20}}>
                        <Grid xs={12} md={12}>
                            <Grid container spacing={8}>
                                <Grid item md={12}>
                                    <Typography variant="headline" component="h3" gutterBottom>
                                        Venue Manager Contact
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Divider />
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <TextField
                                        id="manageContactName"
                                        label="Contact Name"
                                        margin="dense"
                                        fullWidth
                                        value={manageContactName}
                                        onChange={this.handleContactName}
                                        error={this.anyError("manageContactName")}
                                        helperText={this.errorText("manageContactName")}
                                    />
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <TextField
                                        id="manageContactEmail"
                                        label="Email"
                                        margin="dense"
                                        fullWidth
                                        value={manageContactEmail}
                                        onChange={this.handleManageContactEmail}
                                        error={this.anyError("manageContactEmail")}
                                        helperText={this.errorText("manageContactEmail")}
                                    />
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <TextField
                                        id="manageContactPhone"
                                        label="Phone"
                                        margin="dense"
                                        fullWidth
                                        value={manageContactPhone}
                                        onChange={this.handleContactPhone}
                                        error={this.anyError("manageContactPhone")}
                                        helperText={this.errorText("manageContactPhone")}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={8} style={{marginTop:5}}>
                                <Grid item md={12}>
                                    <Typography variant="headline" component="h3" gutterBottom>
                                        Venue Accounts Contact
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Divider />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="venueLegalEntityName"
                                        label="Venue Legal Entity Name"
                                        margin="dense"
                                        fullWidth
                                        value={venueLegalEntityName}
                                        onChange={this.setVenueLegalEntityName}
                                        error={this.anyError("venueLegalEntityName")}
                                        helperText={this.errorText("venueLegalEntityName")}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="venueContactName"
                                        label="Accounts Contact Name"
                                        margin="dense"
                                        fullWidth
                                        value={venueContactName}
                                        onChange={this.setVenueContactName}
                                        error={this.anyError("venueContactName")}
                                        helperText={this.errorText("venueContactName")}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="venueEmail"
                                        label="Email"
                                        margin="dense"
                                        fullWidth
                                        value={venueEmail}
                                        onChange={this.setVenueEmail}
                                        error={this.anyError("venueEmail")}
                                        helperText={this.errorText("venueEmail")}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="venuePhone"
                                        label="Phone Number"
                                        margin="dense"
                                        fullWidth
                                        value={venuePhone}
                                        onChange={this.setVenuePhone}
                                        error={this.anyError("venuePhone")}
                                        helperText={this.errorText("venuePhone")}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>

                                </Grid>
                                </Grid>
                                

                                <Grid container spacing={8}>
                                <Grid item md={12}>
                                    <Typography variant="headline" component="h3" gutterBottom>
                                        Venue Address
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Divider />
                                </Grid>
                                <Grid item xs={12} lg={8}>
                                    <TextField
                                        id="streetAddress"
                                        label="Street Address"
                                        margin="dense"
                                        fullWidth
                                        value={streetAddress}
                                        onChange={this.handleStreetChangeOutgoing}
                                        error={this.anyError("streetAddress")}
                                        helperText={this.errorText("streetAddress")}
                                    />
                                </Grid>

                                <Grid item xs={12} lg={4}>
                                    <TextField
                                        id="suburb"
                                        label="Suburb"
                                        margin="dense"
                                        fullWidth
                                        value={suburb}
                                        onChange={this.handleCityChangeOutgoing}
                                        error={this.anyError("suburb")}
                                        helperText={this.errorText("suburb")}
                                    />
                                </Grid>

                                <Grid item xs={12} lg={4}>
                                    <TextField
                                        id="state"
                                        label="State"
                                        margin="dense"
                                        fullWidth
                                        value={state}
                                        onChange={this.handleStateChangeOutgoing}
                                        error={this.anyError("state")}
                                        helperText={this.errorText("state")}
                                    />
                                </Grid>

                                <Grid item xs={12} lg={4}>
                                    <TextField
                                        id="postCode"
                                        label="Postal/Zip Code"
                                        margin="dense"
                                        fullWidth
                                        value={postCode}
                                        onChange={this.handlePostalChangeOutgoing}
                                        error={this.anyError("postCode")}
                                        helperText={this.errorText("postCode")}
                                    />
                                </Grid>

                                <Grid item xs={12} lg={4} className="select-field-country">
                                    <SelectField
                                        id="countriesOutgoing"
                                        multi={false}
                                        suggestions={countriesSuggestion()}
                                        onChange={this.handleCountryChangeOutgoing}
                                        value={country}
                                        placeholder=" "
                                        label="Country"
                                        margin="dense"
                                        error={this.anyError("countriesOutgoing")}
                                        helperText={this.errorText("countriesOutgoing")}
                                    />
                                </Grid>
                            </Grid>
                            
                        </Grid>
                    </Grid> 
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.onClose}>Close</Button>
                    <Button id="btn-confirm-processbooking" onClick={this.handleSubmit} color="primary" className="process-booking">
                        Save
                    </Button>
                </DialogActions>
            </ModalContainer>
        );
    }
}

export default AgentVenueContactModal;
